import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import Button from '@repo/ui/button'
import { InformationIcon, PdfIcon } from '@repo/ui/icons'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@repo/ui/tooltip'
import Typography from '@repo/ui/typography'
import { useState } from 'react'

import OpenLinkIcon from '../../../../../../packages/ui/icons/open-link'

type Props = {
  disabled?: boolean
  mode: 'link' | 'pdf'
  label: string
  tooltipContent?: string
  showTooltipIcon?: boolean
  onClick?: () => void
}

const ResourceAccessItem = ({
  mode,
  label,
  tooltipContent,
  disabled = false,
  showTooltipIcon = false,
  onClick
}: Props) => {
  const [open, setOpen] = useState(false)
  const Icon = mode === 'link' ? OpenLinkIcon : PdfIcon
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={disabled && open} onOpenChange={setOpen}>
        <div
          className={cn({ 'cursor-not-allowed': disabled })}
          onClick={(e) => {
            if (!disabled) return
            e.preventDefault()
            setOpen((prev) => !prev)
          }}
        >
          <Box className="border border-grey-light rounded-lg p-3 flex justify-between items-center mobile:flex-col mobile:items-start mobile:gap-2">
            <div className="flex items-center gap-2">
              <Icon color={tailwindColors.primary.DEFAULT} className="size-6 min-w-6" />

              <Typography
                variant="tag"
                color={tailwindColors.black.DEFAULT}
                className="text-start w-11/12 mobile:w-full"
              >
                {label}
              </Typography>

              {showTooltipIcon && (
                <TooltipTrigger asChild className={cn({ 'cursor-not-allowed': disabled })}>
                  <div className={'rounded-full bg-red-light w-5 h-5'}>
                    <InformationIcon
                      height={'20'}
                      width={'20'}
                      color={tailwindColors.secondary.DEFAULT}
                    />
                  </div>
                </TooltipTrigger>
              )}
            </div>

            <Button
              disabled={disabled}
              variant="outline"
              onClick={onClick}
              className="text-nowrap mobile:w-full"
              label={mode === 'link' ? 'Voir les informations' : 'Télécharger le PDF'}
            />
          </Box>
        </div>

        <TooltipContent
          align={'center'}
          className={
            'mobile:max-w-xs h-full max-h-48 overflow-y-auto p-3 bg-grey rounded-lg [&::-webkit-scrollbar-thumb]:bg-[#ffffff90]'
          }
        >
          <Typography variant={'label-medium'} color={tailwindColors.white.DEFAULT}>
            {tooltipContent}
          </Typography>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default ResourceAccessItem
